import { createFileRoute } from '@tanstack/react-router'
import AcceptInvitation from '@/pages/auth/accept-invitation/page'

export const Route = createFileRoute('/(auth)/accept-invitation')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AcceptInvitation />
}
